import { Grid } from '@material-ui/core';
import QCXFinalForm from '../../../../../../../shared-components/final-form/QCXFinalForm';
import QCXFinalTextField from '../../../../../../../shared-components/final-text-field/QCXFinalTextField';
import {
  required as requiredValidator,
} from '../../../../../../../utils/validators/field/validator';
import TipoCampoSelect from './TipoCampoSelect';

export default function QCXOcorrenciaFinalForm({
  isCreate,
  isConsult,
  isUpdate,
  model,
  handleSubmit,
  authInfo = {},
  requiredRoles = [],
  ...restProps
}) {
  return (
    <QCXFinalForm
      isCreate={isCreate}
      isConsult={isConsult}
      isUpdate={isUpdate}
      initialValues={model}
      handleSubmitValues={handleSubmit}
      authInfo={authInfo}
      requiredRoles={requiredRoles}
      {...restProps}
    >
      {() => (
        <>
          <Grid
            item
            xs={6}
          >
            <QCXFinalTextField
              id="text-field-description"
              key="text-field-description"
              label="Descrição"
              name="description"
              maxLength={40}
              validate={requiredValidator}
              disabled={isConsult}
              required
            />
          </Grid>
          <Grid
            item
            xs={6}
          >
            <TipoCampoSelect
              id="select-field-tipo"
              key="select-field-tipo"
              name="tipoCampo"
              label="Tipo"
              validate={requiredValidator}
              disabled={isConsult}
              required
            />
          </Grid>
        </>
      )}
    </QCXFinalForm>
  );
}
